
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqD4Ku8JSiTapkvxuH7gWjFvtzwB4fHBFIu29FUHyOgbgMeta } from "/codebuild/output/src261742167/src/src/pages/faq.vue?macro=true";
import { default as menun8HO_45w6ixTssUC_GeyNYWEq0p2vSp3n2KZUmMGQ2w9MMeta } from "/codebuild/output/src261742167/src/src/pages/menu.vue?macro=true";
import { default as index8D5CHEPe_455yuSnz4qG7WORuNguZm_xlijviAN2ijaM4Meta } from "/codebuild/output/src261742167/src/src/pages/index.vue?macro=true";
import { default as contactKKcU0eLJpqmbQpxBdAujBwIrYtXyoOoyRzSH2PLKiTwMeta } from "/codebuild/output/src261742167/src/src/pages/contact.vue?macro=true";
import { default as tutorialCwd_459V84eKE45m2pLJawoOUnzUT_45O_45hrRMTML2cndBUMeta } from "/codebuild/output/src261742167/src/src/pages/tutorial.vue?macro=true";
import { default as agreementDoFf_PFGOLPwofcG7utZkghQ3Os69DOFulUpA2Yco4AMeta } from "/codebuild/output/src261742167/src/src/pages/agreement.vue?macro=true";
import { default as about_45passhkdjsgzis_18PM38z8n9FFOEojncLcFQutFD3NNhsFYMeta } from "/codebuild/output/src261742167/src/src/pages/about-pass.vue?macro=true";
import { default as index7hyXCJdoE_AMIG3eMn2UTvKW85Pren4tjBibFMS6crcMeta } from "/codebuild/output/src261742167/src/src/pages/card/index.vue?macro=true";
import { default as _91id_933k19ENzEguq8MsuyN_45A_Q9kIdiVCW_45DxCIEewoGRtMoMeta } from "/codebuild/output/src261742167/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancejNG3maYi8UxQV9trJiWC5FtBSyEMCf67Ce7FH8EZHfwMeta } from "/codebuild/output/src261742167/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93UClw6Z4Ooj79M2UoV5TUUTsEvVaFJquCKB2bHRyJPIMMeta } from "/codebuild/output/src261742167/src/src/pages/notice/[id].vue?macro=true";
import { default as indexCAYKno7GwWhfE_45Kjp7HwLvyLajLznTasb3XmvI8F1zQMeta } from "/codebuild/output/src261742167/src/src/pages/coupon/index.vue?macro=true";
import { default as indexr6ixzgKkNqq_45ZdGEylFz1LubKaWVz1hndr_P_RiSsp0Meta } from "/codebuild/output/src261742167/src/src/pages/mypage/index.vue?macro=true";
import { default as indexaRB2xd2wBicQ0nlpmtusNNJ3ifKcDXQHJomDpsTlDlcMeta } from "/codebuild/output/src261742167/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93m2SZDN6wBfqV8w4llVHByVhGq0FHd7W_v6f8Wg_45YBnIMeta } from "/codebuild/output/src261742167/src/src/pages/parking/[id].vue?macro=true";
import { default as indexl2uH5bJr3yQrCeicd_WHp0uhgtj_45gfj7H2eXTxs_yHQMeta } from "/codebuild/output/src261742167/src/src/pages/history/index.vue?macro=true";
import { default as indexZW7vJpdhde3yKVrcWL4TzMursi6AOuVGj9YYuYOrKiIMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/index.vue?macro=true";
import { default as indexIndNdHv4AwmQpOJS0FsUf1uIGVxou3DmGQ6URUyCHFUMeta } from "/codebuild/output/src261742167/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexNZ8wHZJunjPXjrnIiM2qw55LEn5OaPJiDEPECcbsyZUMeta } from "/codebuild/output/src261742167/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviBzSEihdi9BlRXAVGP97yENKpClNbMtQy5iD0CrxPQJ0Meta } from "/codebuild/output/src261742167/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editGGHHKK0_45cBBuiU6wF_GY3eRmK9hXzawblZVcYgHas8kMeta } from "/codebuild/output/src261742167/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementqzOj37izMJeS4dFWWxiMTalC6zeFYIalJFXBQNZg5lYMeta } from "/codebuild/output/src261742167/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexQ14Rfsxy55QHueIos_XfHvW9f9IRNWxzCdYdpkRUqUkMeta } from "/codebuild/output/src261742167/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dO_45AziudbiGZQJMaNRJhWK71IssRtvdIZFjdXZpZL_45vAMeta } from "/codebuild/output/src261742167/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmOdMkOgxkovItT_45wmKSQ1A8RgLRNOG62XEy3mEZ2jOSYMeta } from "/codebuild/output/src261742167/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexFaDun6RpJbgBUvF_45n5fv0ZmL0Iu80h3gy1KZ6I6SjKgMeta } from "/codebuild/output/src261742167/src/src/pages/card/create/index.vue?macro=true";
import { default as indexpP2ixWYcEDmdgPuKiwtbc14HbdVuZ_dore2DS8ifKs8Meta } from "/codebuild/output/src261742167/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmedayOMIuATMrGlV_RqFpTisUkc2lXep242eKXcxEyfcMeta } from "/codebuild/output/src261742167/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm4znnLjxgVZSYY37dax44P4kldgV3LpX3rUHV_45rCs2YgMeta } from "/codebuild/output/src261742167/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completef8nZSH_45IIvcZp7IXiMnshV6TMTJ65kfBfVhBW0_xtqoMeta } from "/codebuild/output/src261742167/src/src/pages/membership/complete.vue?macro=true";
import { default as registerDb1kZZyZtQ1WEvJe73NknKCEkjkg97rPedsuQQRPQH4Meta } from "/codebuild/output/src261742167/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_932lV_45e8oInwfGh2DHM4rw35rimnWLWWV2FW2zfn51zdMMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmI2DrLgXNRHIjH5CEWLr6tZxhv4nt2cNtVmVN30ESLi4Meta } from "/codebuild/output/src261742167/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93GmWVWyPWnipoYqRyjh8vw_450e15pUzZUZa51YiJW_ZVAMeta } from "/codebuild/output/src261742167/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexouh_45NP7_Uul0YqL3thzuOPETB9JGywIkN6_Uwf6f4TEMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeXfxGHG1FQEFk8_45JqQEaNRRURAKLwafcuZZD4Q3GQ7_45AMeta } from "/codebuild/output/src261742167/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code79avnVeEt1bLFRAmcIF2FPvU6AqoV3YgETO6GTgzRQQMeta } from "/codebuild/output/src261742167/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeaxJHGaa_45mklSn_451Sw_45Lkq0JotlVtAVdoHzVCbEwZqMsMeta } from "/codebuild/output/src261742167/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register6IX7j5UOnl4H9IiYEfCR_45yZq62TJGQuzBh_ktgQlrm4Meta } from "/codebuild/output/src261742167/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeeTHbCCP0tYIiXIZUht6bU9TkkyjbFlePm_68YepGL_kMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexpDaRmks8lU4l_45NvkUzBt2mqxyObSPupB5QjXdLRs3WUMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmnmeuVDQhDmETzsKmyIeuXjzmdH0Jxn6BOyYk3vc1iWgMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeBxUCHwRUanzbVLI22IO2kw9T_45cLKvREm5xnkOT86YO0Meta } from "/codebuild/output/src261742167/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexG9Qf_FTuuhGYFqAvlC4UZIEeMDng7QQz1xHNWVrb_9EMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93ADfyi0kO1fz4Yog5bIi4yoZxZfZ8KG2QqbJWfbJ8FesMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completevPudRrV__wg_45xtxZNP8072FCDIe7KRUhMoqlXR2hQNAMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasogukTaVjnQALKhWQRxfjoAzYQ5GU9h3YzKq6BY7YbNoMeta } from "/codebuild/output/src261742167/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleyYfcJx_xtqgu6iNDy0ceR_45dRR7ndWopw3RixAC3jOPwMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailqXjEQaXCxEqd0S_Gp9p6267Mj7gvPd8wE_45J_yRg4j5wMeta } from "/codebuild/output/src261742167/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmMgP4sjrF6rjXN_45SgI91DqW7yZVSOZc_45QQmjUFcpNcWkMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentwVfJ1TYymRjNMY1OefKPlTx4ih3aUD1kRvIf7P5KWxMMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmcGKEykT7uoYvT2m2h8wjpDM1cDjm3I9fEraZa0GgQ2AMeta } from "/codebuild/output/src261742167/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateu8yd_45A4yumlGKqRw9wac2XYbY3AXc2BMtUXG0NTM8ekMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completetr3MgI6Cqk24v1ev7i8GV30I8cos1bWhxPimcoWtODQMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codee9zyF_45POzKaaEwUL6qLcfg5K9T6WCPWa2vXGCMfSxu4Meta } from "/codebuild/output/src261742167/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password4dhB8u7l2Vob2z_C5fJTFVTCc_45LN4pxw_M5NwZyVPGYMeta } from "/codebuild/output/src261742167/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasAN0gn2LAFMcE_45Xo1oo8kuISiPOcEF_45FcHaK_OpjYIfMMeta } from "/codebuild/output/src261742167/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerjU9WCWDSkxY25jDsjzsWIxr9Wwk4Fdi_45xUrpf8Kazl0Meta } from "/codebuild/output/src261742167/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeAYnmtz8NJDlpLyEDJCvckiYO0welFA16_45DH759Flup4Meta } from "/codebuild/output/src261742167/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexOlcYm99ptImpbCJYkNr7iipFZWz6J4CazkgUqTUxE1AMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexLWYRVGGVW_45YXd2Oz5QrAnCcXdWpPJJC532rM_zE2n8IMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexMe5XqRoatdzHle4iasPHPoFX7sOPwbnr7KRpEKJYEsgMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexaGHPFUUuJY640GVnUfi9_qdv2FnPEMGsSwTOQw4OffgMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatekqYfbahqlm8QV4DJ6Ee26CVXWfULmiWQAAcYrSLGmZ8Meta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeVZZa6lmUEGu84U7g1AJfZmmlQOSJJJPsy0rZibpFKI4Meta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmm8f9pdBSgw66U1aOdJCjaSDilOl1dkF6Ep_45pk_45iarp4Meta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexUoQH6E_450m3Vk7bWjr8LmxSSqzkUmV4r3YiSEcwGl4D0Meta } from "/codebuild/output/src261742167/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completel8RjlVg7fljZKcdYU_45ddSJdlWwlQ4EA5NUtVPo8b4VEMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateYinAwzfswXdjQGmifp_ywanmRZyQXEsFgZK3LlE6rH0Meta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index2n__lux7zMv_45Vm0hViEprr6owt4TSLVIJ1ehXtydwkkMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexHK297cFBNBvcev1Q8qYIcBJeZa4pfx6qZ44Sns4fl5EMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completekjNjV9BgLuUCfzNzDiklFJaTr7xaCCG1tqC4lsQBODUMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexBZWM_45rIKKQ4a_45kUhvx00qE7YLun2qaEtrw9rF4OrAlwMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code1e9_451jWstIOwWt24T2n2Gh09smKzN5QvadNmSGk8vTsMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexJyBB2gY46iLtx2oHr_45lTg57keBZi4OTKBd_45ybHHkOHYMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexVH10fo3Nb_45GT8Rg2hsPNBMTxx4pglSBTm8xX6B1i22oMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexuWutLz48x_45ATXiWCintUVfuRd3N1deueogtNdZyvy9AMeta } from "/codebuild/output/src261742167/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateEupUCpNqNu96Pi7eO83wcVLB26zcLi7xMcvqJhMjXg0Meta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmq8uDuWGQceY71YiKyElwG0brKygllmd8BLvKMSgaI2IMeta } from "/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src261742167/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menun8HO_45w6ixTssUC_GeyNYWEq0p2vSp3n2KZUmMGQ2w9MMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index8D5CHEPe_455yuSnz4qG7WORuNguZm_xlijviAN2ijaM4Meta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src261742167/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src261742167/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src261742167/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src261742167/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src261742167/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexCAYKno7GwWhfE_45Kjp7HwLvyLajLznTasb3XmvI8F1zQMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src261742167/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src261742167/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexl2uH5bJr3yQrCeicd_WHp0uhgtj_45gfj7H2eXTxs_yHQMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexIndNdHv4AwmQpOJS0FsUf1uIGVxou3DmGQ6URUyCHFUMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexNZ8wHZJunjPXjrnIiM2qw55LEn5OaPJiDEPECcbsyZUMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src261742167/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src261742167/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexFaDun6RpJbgBUvF_45n5fv0ZmL0Iu80h3gy1KZ6I6SjKgMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmedayOMIuATMrGlV_RqFpTisUkc2lXep242eKXcxEyfcMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm4znnLjxgVZSYY37dax44P4kldgV3LpX3rUHV_45rCs2YgMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completef8nZSH_45IIvcZp7IXiMnshV6TMTJ65kfBfVhBW0_xtqoMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerDb1kZZyZtQ1WEvJe73NknKCEkjkg97rPedsuQQRPQH4Meta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmI2DrLgXNRHIjH5CEWLr6tZxhv4nt2cNtVmVN30ESLi4Meta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeXfxGHG1FQEFk8_45JqQEaNRRURAKLwafcuZZD4Q3GQ7_45AMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code79avnVeEt1bLFRAmcIF2FPvU6AqoV3YgETO6GTgzRQQMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeaxJHGaa_45mklSn_451Sw_45Lkq0JotlVtAVdoHzVCbEwZqMsMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register6IX7j5UOnl4H9IiYEfCR_45yZq62TJGQuzBh_ktgQlrm4Meta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmnmeuVDQhDmETzsKmyIeuXjzmdH0Jxn6BOyYk3vc1iWgMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeBxUCHwRUanzbVLI22IO2kw9T_45cLKvREm5xnkOT86YO0Meta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexG9Qf_FTuuhGYFqAvlC4UZIEeMDng7QQz1xHNWVrb_9EMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completevPudRrV__wg_45xtxZNP8072FCDIe7KRUhMoqlXR2hQNAMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleyYfcJx_xtqgu6iNDy0ceR_45dRR7ndWopw3RixAC3jOPwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailqXjEQaXCxEqd0S_Gp9p6267Mj7gvPd8wE_45J_yRg4j5wMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmMgP4sjrF6rjXN_45SgI91DqW7yZVSOZc_45QQmjUFcpNcWkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentwVfJ1TYymRjNMY1OefKPlTx4ih3aUD1kRvIf7P5KWxMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmcGKEykT7uoYvT2m2h8wjpDM1cDjm3I9fEraZa0GgQ2AMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completetr3MgI6Cqk24v1ev7i8GV30I8cos1bWhxPimcoWtODQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codee9zyF_45POzKaaEwUL6qLcfg5K9T6WCPWa2vXGCMfSxu4Meta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password4dhB8u7l2Vob2z_C5fJTFVTCc_45LN4pxw_M5NwZyVPGYMeta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src261742167/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerjU9WCWDSkxY25jDsjzsWIxr9Wwk4Fdi_45xUrpf8Kazl0Meta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeAYnmtz8NJDlpLyEDJCvckiYO0welFA16_45DH759Flup4Meta || {},
    component: () => import("/codebuild/output/src261742167/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src261742167/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src261742167/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]